import car from 'assets/images/CAR.svg';

export const editDriverDialogData = (details) => [
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue: details?.mobile?.replaceAll('+91', '') || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue: details?.email || '',
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    countrycode: false,
    defaultValue: details?.vendorName || '',
    disabled: true,
  },
];
export const editSubDriverDialogData = (details) => [
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'vendorName',
    label: 'Driver Name',
    countrycode: false,
    defaultValue: details?.name || '',
  },
  {
    placeholder: 'Mobile Number',
    required: false,
    type: 'text',
    name: 'number',
    label: 'Mobile Number',
    countrycode: true,
    defaultValue: details?.mobile?.replaceAll('+91', '') || '',
  },
  {
    placeholder: 'Email',
    required: false,
    type: 'text',
    name: 'email',
    label: 'Email',
    countrycode: false,
    defaultValue: details?.email || '',
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'name',
    label: 'City Manager',
    countrycode: false,
    defaultValue: details?.vendorName || '',
    disabled: true,
  },
  {
    placeholder: 'Name',
    required: false,
    type: 'text',
    name: 'subVendorName',
    label: 'Sub-Vendor Name',
    countrycode: false,
    defaultValue: details?.subVendorName || '',
    disabled: true,
  },
];

export const vehicleInfo = (vehicleInfotable) => [
  {
    title: 'Model Name',
    body: vehicleInfotable?.carModel,
  },
  {
    title: 'Vehicle no',
    body: vehicleInfotable?.regNumber,
  },
  {
    title: 'Vehicle Color',
    body: vehicleInfotable?.colour,
  },
  {
    title: 'Fuel type',
    body: vehicleInfotable?.fuelType,
  },
  {
    title: 'Vehicle Capacity',
    body: vehicleInfotable?.seating,
  },
  {
    title: 'Category',
    body: vehicleInfotable?.carType,
  },
  {
    title: 'Chasis No',
    body: vehicleInfotable?.chasisNum,
  },
  {
    title: 'Engine no',
    body: vehicleInfotable?.engineNum,
  },
];

export const amenitiesVehicle = (vehicleInfoaminities) => [
  {
    id: 1,
    image: car,
    title: 'Stepney',
    body: vehicleInfoaminities?.stepney,
  },
  {
    id: 2,
    image: car,
    title: 'Fire Extinguisher',
    body: vehicleInfoaminities?.fireExtinguisher,
  },
  {
    id: 3,
    image: car,
    title: 'First-aid Kit',
    body: vehicleInfoaminities?.firstAid,
  },
  {
    id: 4,
    image: car,
    title: 'Last Vehicle inspection',
    body: vehicleInfoaminities?.lastInspection,
  },
  {
    id: 5,
    image: car,
    title: 'Last Service Date',
    body: vehicleInfoaminities?.lastService,
  },
  {
    id: 6,
    image: car,
    title: 'Last Service Meter Reading',
    body: vehicleInfoaminities?.lastMeterReading,
  },
  {
    id: 7,
    image: car,
    title: 'Average',
    body: vehicleInfoaminities?.average,
  },
];
